import React, { ReactNode } from 'react'
import { Divider, Typography } from '@mui/joy'
import ReactMarkdown from 'react-markdown'

type Props = {
  content?: string,
  images?: { [key: string]: string },
}
const Markdown = ({ content, images }: Props) => {
  return (
    <ReactMarkdown
      components={{
        h2(props) {
          const { node, ...rest } = props
          // @ts-ignore
          return <Typography component='h2' level='h3' sx={{ mb: 2, }} {...rest} />
        },
        h3(props) {
          const { node, ...rest } = props
          // @ts-ignore
          return <Typography component='h3' level='h4' sx={{ mb: 1, }} {...rest} />
        },
        p(props) {
          const { node, ...rest } = props
          // @ts-ignore
          return <Typography level='body-md'  {...rest} />
        },
        hr(props) {
          const { node, ...rest } = props
          // @ts-ignore
          return <Divider sx={{ my: 4 }} {...rest} />
        },
        img(props) {
          const { node, alt, ...rest } = props
          const src = images ? images[alt as keyof object] : props.src

          // @ts-ignore
          return <img  {...rest} src={src} width={900} height={300} style={{ objectFit: 'contain', margin: '1rem', maxWidth: '90vw' }} />
        },
      }}
    >
      {content}
    </ReactMarkdown>
  )
}

export default Markdown